export const EXTERNAL_LINKS = {
  KAKAOTALK_CS_LINK: "http://pf.kakao.com/_yucxkG/chat",
  SMART_STORE_LINK: "https://smartstore.naver.com/root-in-yoga",
  BLOG_LINK: "https://blog.naver.com/rooot-inyoga",
  PHONE_NUMBER: "010-8295-4425",
  EMAIL_ADDRESS: "sthdnjs4498s@naver.com",
};

// Days of week in Korean (Sunday = 0)
export const DAYS_OF_WEEK_KO = [
  "일",
  "월",
  "화",
  "수",
  "목",
  "금",
  "토",
] as const;
